import type { SVGProps } from 'react';

export type UiIconName =
  | 'spark'
  | 'calendar'
  | 'attendance'
  | 'report'
  | 'platform'
  | 'scanner'
  | 'tenant'
  | 'flow'
  | 'shield'
  | 'status'
  | 'check';

export function UiIcon({
  name,
  className,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'children'> & {
  readonly name: UiIconName;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {renderPath(name)}
    </svg>
  );
}

function renderPath(name: UiIconName) {
  switch (name) {
    case 'spark':
      return (
        <>
          <path d="M12 3 13.8 8.2 19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" />
          <path d="M19.5 3.5 20.1 5.4 22 6l-1.9.6-.6 1.9-.6-1.9-1.9-.6 1.9-.6.6-1.9Z" />
        </>
      );
    case 'calendar':
      return (
        <>
          <rect x="3" y="5" width="18" height="16" rx="3" />
          <path d="M8 3v4M16 3v4M3 10h18" />
        </>
      );
    case 'attendance':
      return (
        <>
          <path d="M8 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
          <path d="M5 18c.7-2 2.1-3 4-3s3.3 1 4 3" />
          <path d="M15 8h5M15 12h5M17 16h3" />
        </>
      );
    case 'report':
      return (
        <>
          <path d="M5 20V9" />
          <path d="M10 20V4" />
          <path d="M15 20v-7" />
          <path d="M20 20v-12" />
        </>
      );
    case 'platform':
      return (
        <>
          <rect x="3" y="4" width="18" height="6" rx="2" />
          <rect x="3" y="14" width="8" height="6" rx="2" />
          <rect x="13" y="14" width="8" height="6" rx="2" />
        </>
      );
    case 'scanner':
      return (
        <>
          <path d="M7 4H5a1 1 0 0 0-1 1v2M17 4h2a1 1 0 0 1 1 1v2M7 20H5a1 1 0 0 1-1-1v-2M17 20h2a1 1 0 0 0 1-1v-2" />
          <path d="M8 12h8" />
        </>
      );
    case 'tenant':
      return (
        <>
          <path d="M4 20V7l8-3 8 3v13" />
          <path d="M9 20v-5h6v5" />
        </>
      );
    case 'flow':
      return (
        <>
          <path d="M4 7h6" />
          <path d="m8 3 4 4-4 4" />
          <path d="M20 17h-6" />
          <path d="m16 21-4-4 4-4" />
          <path d="M12 7v10" />
        </>
      );
    case 'shield':
      return (
        <>
          <path d="m12 3 7 3v5c0 4.2-2.8 7.6-7 10-4.2-2.4-7-5.8-7-10V6l7-3Z" />
          <path d="m9.5 12 1.8 1.8 3.8-4" />
        </>
      );
    case 'status':
      return (
        <>
          <path d="M4 12h6" />
          <path d="M14 12h6" />
          <circle cx="12" cy="12" r="2.75" />
        </>
      );
    case 'check':
      return <path d="m5 12 4 4L19 6" />;
  }
}
